export enum RoleEnum {
    SuperUser = 1,
    SocialCareLeader = 2,
    SocialCareManager = 3,
    SocialCareWorker = 4,
    TemporaryUser = 5
}

export enum RoleStringEnum {
    SuperUser = "SuperUser",
    SocialCareLeader = "SocialCareLeader",
    SocialCareManager = "SocialCareManager",
    SocialCareWorker = "SocialCareWorker",
    TemporaryUser = "TemporaryUser"
}
